import React from "react";
import { Link } from "react-router-dom";
import { Clapperboard, Users, PartyPopper } from "lucide-react";

const LINKS = [
  { to: "/coach/show-notes", icon: Clapperboard, title: "Open Show Notes", text: "Review, approve and publish reports." },
  { to: "/coach/members?tab=groups", icon: Users, title: "Manage Groups", text: "Add productions and fine-tune stage manager permissions." },
];

// Final step: quick links.
export default function DoneStep({ onNavigate }) {
  return (
    <div data-testid="theatre-setup-done">
      <div className="mb-5 flex items-center gap-3 rounded-xl bg-emerald-50 px-4 py-3 text-emerald-800">
        <PartyPopper className="h-5 w-5" />
        <p className="text-sm font-semibold">Your Theatre program is ready. You can change any of this later.</p>
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        {LINKS.map((l) => (
          <Link key={l.to} to={l.to} onClick={onNavigate} data-testid={`theatre-setup-link-${l.to.split("/").pop().split("?")[0]}`}
            className="group rounded-xl border border-slate-200 bg-white p-4 transition-[box-shadow,transform] hover:-translate-y-0.5 hover:shadow-md">
            <l.icon className="h-5 w-5 text-slate-700" />
            <p className="mt-2 font-semibold text-slate-900">{l.title}</p>
            <p className="text-sm text-slate-500">{l.text}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
